import { createFileRoute } from "@tanstack/react-router";
import { ComingSoon } from "@/components/ComingSoon";

export const Route = createFileRoute("/_authed/items")({
  component: () => (
    <ComingSoon
      title="Items"
      phase="Phase 5"
      summary="Item catalogue with owner link, linked tag, and claim history."
    />
  ),
});
